import { writable } from 'svelte/store';
export const eventGroupState = writable([]);